// extracted by mini-css-extract-plugin
module.exports = {"surveyTipsListWrapper":"SurveyTips_surveyTipsListWrapper__b4vpB","surveyTipsList":"SurveyTips_surveyTipsList__DgX8g"};